import { useState } from 'react';
import { Card, Button, Space, Upload, message } from 'antd';
import { FileImageOutlined, UploadOutlined, PictureOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import MediaPickerDrawer from './media-picker/MediaPickerDrawer';

interface Props {
  coverUrl: string | null;
  onChange: (v: { coverMediaId: string | null; coverUrl: string | null }) => void;
}

/**
 * 封面照片：可從媒體庫挑既有照片，或上傳新檔。
 * 挑完回寫 coverMediaId／coverUrl，交由自動儲存寫入 DB。
 */
export default function CoverCard({ coverUrl, onChange }: Props) {
  const [picker, setPicker] = useState(false);

  const uploadCover = useMutation({
    mutationFn: (file: File) => api.uploadImage(file),
    onSuccess: ({ id, url }) => {
      onChange({ coverMediaId: id, coverUrl: url });
      message.success('封面已設定');
    },
    onError: (e: Error) => message.error(e.message),
  });

  return (
    <Card title="封面照片">
      {coverUrl ? (
        <img
          src={coverUrl}
          alt="封面"
          className="mb-2 aspect-[16/10] w-full rounded-lg object-cover ring-1 ring-black/5"
        />
      ) : (
        <div className="mb-2 flex aspect-[16/10] w-full items-center justify-center rounded-lg bg-[#fbf3e8] text-[#dd7900]/45 ring-1 ring-[#dd7900]/10">
          <FileImageOutlined style={{ fontSize: 28 }} />
        </div>
      )}
      <Space wrap>
        <Button type="primary" ghost icon={<PictureOutlined />} onClick={() => setPicker(true)}>
          從媒體庫挑選
        </Button>
        <Upload
          showUploadList={false}
          accept="image/*"
          beforeUpload={(file) => {
            uploadCover.mutate(file);
            return false;
          }}
        >
          <Button icon={<UploadOutlined />} loading={uploadCover.isPending}>
            上傳新檔
          </Button>
        </Upload>
        {coverUrl && (
          <Button danger onClick={() => onChange({ coverMediaId: null, coverUrl: null })}>
            移除
          </Button>
        )}
      </Space>

      <MediaPickerDrawer
        open={picker}
        title="挑選封面照片"
        onClose={() => setPicker(false)}
        onPick={(m) => {
          onChange({ coverMediaId: m.id, coverUrl: m.url });
          message.success('封面已設定');
        }}
      />
    </Card>
  );
}
